module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-144x144-b62adc1435a34cfb2f57f2b99decbfec.png";